const OFFSCREEN = -100000;
export const OFFSCREEN_RECT = {
    left: OFFSCREEN,
    right: OFFSCREEN,
    top: OFFSCREEN,
    bottom: OFFSCREEN,
    width: 0,
    height: 0,
};
//# sourceMappingURL=popper.js.map